import type { PathParams } from './path-params';
import type { KnownRoute } from './routes';

/**
 * @deprecated Prefer `router.buildLocation(...)` for Hydra-owned pages. Retained for
 * embedded/manual routes in `ROUTES`, and for building embedded-app hrefs to
 * tree-registered paths that carry embedded-only query params the TanStack route does
 * not declare (e.g. the integrations directory's `selectedCategory`/`selectedType`).
 */
export function generatePath<Path extends KnownRoute>(
  path: Path,
  params: PathParams<Path>,
  query?: Record<string, string | number | boolean | undefined | null>,
  hash?: string,
): string {
  const base = path.replace(/:([^/]+)/g, (_, key: string) => {
    // oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
    const value = params[key as keyof typeof params];
    if (value == null) {
      throw new Error(`Missing ":${key}" param`);
    }

    return String(value);
  });

  const searchParams = new URLSearchParams();
  if (query != null) {
    for (const [key, value] of Object.entries(query)) {
      if (value != null) {
        searchParams.set(key, String(value));
      }
    }
  }

  const search = searchParams.toString();
  const withSearch = search.length > 0 ? `${base}?${search}` : base;
  return hash != null ? `${withSearch}#${hash}` : withSearch;
}
